import { ParameterTypeEnum, PayrollParameters } from '@akiba/models_beta_temp';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-payroll-modal',
  templateUrl: './create-payroll-modal.component.html',
  styleUrls: ['./create-payroll-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreatePayrollModalComponent implements OnInit, OnChanges {

  parameterTypeEnum: typeof ParameterTypeEnum = ParameterTypeEnum;
  parameter: PayrollParameters | undefined;
  @Input() parameterType: ParameterTypeEnum = ParameterTypeEnum.NotSet;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parameterType'] && changes['parameterType'].currentValue) {
      this.parameterType = changes['parameterType'].currentValue;
      this.procType();
    }
  }

  procType(): void {

    if (this.parameterType === ParameterTypeEnum.NotSet) {
      this.activeModal.dismiss(undefined);
    }

    const date = new Date();
    switch (this.parameterType) {
      case ParameterTypeEnum.Payroll:
        this.parameter = new PayrollParameters();
        this.parameter.payrollID = date.getTime().toString();
        break;

      case ParameterTypeEnum.LockOut:
        this.parameter = new PayrollParameters();
        this.parameter.payrollID = date.getTime().toString();
        break;

      default:
        break;

    }

  }

  createdParameter(): void {
    this.activeModal.close(this.parameter);
  }

}
